// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1VWmS","list":"BalanceDue_list__1NjKW","listRow":"BalanceDue_listRow__Ksaia","total":"BalanceDue_total__2uXB-"};